import React from 'react';
import { Row, Col, Card, Typography, Icon } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { AppState } from 'store';
import { useSelector } from 'react-redux';
import { userUsageReportAccessFlagSelector } from 'pages/UserUsageReport';
const { Title } = Typography;

const menu = [
  {
    index: 0,
    link: '/pages/nyc-online-abstract',
    header: 'NYC Online Abstract',
    icon: 'database',
    body: (
      <ul>
        <li>Judgments/Liens</li>
        <li>Environmental Control Board (ECB’s)</li>
        <li>Parking Violations Bureau (PVB’s)</li>
        <li>Uniform Commercial Code (UCC's)</li>
        <li>Federal Tax Liens (FTL's)</li>
        <li>Transit Adjudication Bureau</li>
        <li>Mortgage/Deeds</li>
        <li>NYC ER's</li>
      </ul>
    ),
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 1,
    link: '/pages/property-look-up',
    header: ' Property Look Up',
    icon: 'search',
    body: 'A comprehensive database that provides instant access to basic property information in all New York State counties.',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 2,
    link: '/pages/tax-maps',
    header: 'Tax Maps',
    icon: 'environment',
    body: 'Retrieve Tax Maps in Manhattan, Bronx, Kings, Queens, Richmond, Nassau, Suffolk, Dutchess, Orange, Putnam, Rockland.',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 3,
    link: '/pages/dep-online',
    header: 'NYC DEP Online',
    icon: 'home',
    body: 'NYC DEP Online',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 4,
    link: '/pages/bankruptcy',
    header: 'National Name Database',
    icon: 'global',
    body: (
      <ul>
        <li>Bankruptcy Searches</li>
        <li>Patriot Searches</li>
      </ul>
    ),
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 5,
    link: '/pages/preacris',
    header: 'DocuTrax: Document Images',
    icon: 'file',
    body: (
      <ul style={{ color: '#40a9ff', fontWeight: 'bold' }}>
        <li>Retrieve Copies of Documents (46 states)</li>
        <li>*New* NYC images prior to ACRIS (1654-1966)</li>
      </ul>
    ),
    version: ['Dev', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 6,
    link: '/pages/taxtrax',
    header: 'TaxTrax: Tax Status',
    icon: 'dollar',
    body: 'Your online tax status specialists.',
    version: ['Dev', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 7,
    link: '/pages/recent-reports',
    header: 'Recent Reports',
    icon: 'file-search',
    body: 'Retrieve searches and reports previously ran on this system.',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  {
    index: 8,
    link: '/pages/usage-report',
    header: 'Usage Reports',
    icon: 'team',
    body: 'Retrieve billing info of your customers or groups for previously ran searches.',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
    requiresBillingInfoAccess: true,
  },
  {
    index: 9,
    link: '/pages/user-manual',
    header: 'User Manual',
    icon: 'question-circle',
    body: 'Access Demos and User Guides',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },
  /**{
    index: 7,
    link: '/pages/Preacris',    
    header: 'Test Doc Images',
    icon: 'file',
    body: 'Retrieve Copies of Document (46 states), NYS UCC Filings and NYC images prior to ACRIS (1966)',
    version: ['Test', 'Dev', 'Prod', 'Staging'],
  },**/
];

const Dashboard: React.FC = () => {
  const { login, userUsageReportAccessFlag } = useSelector(
    (state: AppState) => ({
      login: state.login,
      userUsageReportAccessFlag: userUsageReportAccessFlagSelector(state),
    }),
  );

  if (login.user?.licenseflag == 'False') {
    return <Redirect to={`/pages/license`} />;
  }

  return (
    <Row gutter={[16, 16]} type="flex" id="dashboard">
      {menu
        .filter(
          (item) =>
            item.version.indexOf(process.env.REACT_APP_VERSION as string) !==
            -1,
        )
        .sort((a, b) => a.index - b.index)
        .map((item) => {
          return (
            (!item.requiresBillingInfoAccess || userUsageReportAccessFlag) && (
              <Col xs={24} md={12} lg={8} key={item.header}>
                <Link to={item.link}>
                  <Card size="small" hoverable className={'h-100'}>
                    <Typography>
                      <Title level={4}>
                        <Icon type={item.icon} />
                        &nbsp;{item.header}
                      </Title>
                      {item.body}
                    </Typography>
                  </Card>
                </Link>
              </Col>
            )
          );
        })}
    </Row>
  );
};

export default Dashboard;
